export const parseBase64Image = (dataUrl: string) => {
  const [header, base64Data] = dataUrl.split(',')
  const [, mimeType] = header.match(/data:(.*?);base64/) || []

  return {
    mimeType: mimeType || '',
    base64Data
  }
}
